import { useState, useEffect } from "react";

const CITIES = [
  { name: "DELHI", lat: "28.6139° N", lon: "77.2090° E" },
  { name: "NOIDA", lat: "28.5355° N", lon: "77.3910° E" },
  { name: "GURUGRAM", lat: "28.4595° N", lon: "77.0266° E" },
  { name: "KOLKATA", lat: "22.5726° N", lon: "88.3639° E" },
  { name: "BENGALURU", lat: "12.9716° N", lon: "77.5946° E" },
  { name: "CHENNAI", lat: "13.0827° N", lon: "80.2707° E" },
  { name: "MUMBAI", lat: "19.0760° N", lon: "72.8777° E" },
  { name: "PUNE", lat: "18.5204° N", lon: "73.8567° E" },
  { name: "JAIPUR", lat: "26.9124° N", lon: "75.7873° E" }
];

export default function DynamicCoordinates({ prefix = "" }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((current) => (current + 1) % CITIES.length);
    }, 4000); // Change city every 4 seconds
    return () => clearInterval(interval);
  }, []);

  const city = CITIES[index];
  
  if (prefix === "LAT ") {
    return <span>{prefix}{city.lat} / LON {city.lon}</span>;
  }
  
  return <span>{city.lat} / {city.lon}</span>;
}
